// extracted by mini-css-extract-plugin
export default {"input":"VerifyCodeInput_input__kyfGD","display":"VerifyCodeInput_display__i82pV","shadows":"VerifyCodeInput_shadows__JauFO"};